import { render, staticRenderFns } from "./usercard.vue?vue&type=template&id=e59bb28c&scoped=true"
import script from "./usercard.vue?vue&type=script&lang=js"
export * from "./usercard.vue?vue&type=script&lang=js"
import style0 from "./usercard.vue?vue&type=style&index=0&id=e59bb28c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59bb28c",
  null
  
)

export default component.exports